import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Router } from '@angular/router';

import { environment } from 'src/environments/environment';
import { UtilService } from 'src/app/modules/shared/services/util.service';

@Injectable({
  providedIn: 'root'
})
export class LoginService {

  constructor(
    private _router: Router,
    private _utilService: UtilService,
    private _httpClient: HttpClient
  ) { }

  // Store login
  userLogin(body: any){
    const URL = environment.apiUrl + 'dashboard/login';
    let reqHeaders = new HttpHeaders()
      .set('Content-Type', 'application/json');
    let reqBody = JSON.stringify(body);

    return this._httpClient.post<any>(URL, reqBody, {headers: reqHeaders});
  }

  // Get retailer list
  getRetailers(token: string, body: any){
    const URL = environment.apiUrl + 'dashboard/retailers';
    let reqHeaders = new HttpHeaders()
      .set('Content-Type', 'application/json')
      .set('authToken', token);
    let reqBody = JSON.stringify(body);

    return this._httpClient.post<any>(URL, reqBody, {headers: reqHeaders});
  }

  // Get category list
  getCategories(token: string, providerType : string, providerId: string){
    const URL = environment.apiUrl + 'dashboard/categories';
    let reqHeaders = new HttpHeaders()
      .set('Content-Type', 'application/json')
      .set('authToken', token);
    let reqParams = new HttpParams()
      .set('provider_type', providerType)
      .set('provider_id', providerId);

    return this._httpClient.get<any>(URL, {headers: reqHeaders, params: reqParams});
  }

  // Get manufacturer list
  getManufacturers(token: string, providerType : string, providerId: string, brandLink: boolean){
    const URL = environment.apiUrl + 'dashboard/manufacturers';
    let reqHeaders = new HttpHeaders()
      .set('Content-Type', 'application/json')
      .set('authToken', token);
    let reqParams = new HttpParams()
      .set('provider_type', providerType)
      .set('provider_id', providerId)
      .set('brand_link', brandLink);

    return this._httpClient.get<any>(URL, {headers: reqHeaders, params: reqParams});
  }

  // Get brand list
  getBrands(token: string, providerType : string, providerId: string, mfgId: any){
    const URL = environment.apiUrl + 'dashboard/brands';
    let reqHeaders = new HttpHeaders()
      .set('Content-Type', 'application/json')
      .set('authToken', token);
    let reqParams = new HttpParams()
      .set('provider_type', providerType)
      .set('provider_id', providerId)
      .set('mfg_id', mfgId);

    return this._httpClient.get<any>(URL, {headers: reqHeaders, params: reqParams});
  }

  // Change password
  changeUserPassword(token: string, body: any){
    const URL = environment.apiUrl + 'dashboard/changeUserPassword';
    let reqHeaders = new HttpHeaders()
      .set('Content-Type', 'application/json')
      .set('authToken', token);
    let reqBody = JSON.stringify(body);

    return this._httpClient.post<any>(URL, reqBody, {headers: reqHeaders});
  }
  
}
